import * as React from 'react';
import classNames from 'classnames';
import { useLocation} from 'react-router-dom'



const TransactionProgress  = props => {
  const {activeStep} = props;
  const location = useLocation()
  const {pathname} = location
  const pathName= pathname.split('/')
  const finalPathName = pathName[2]

  return (
    <>

        <div className='application-progress'>
          <div className="item">
            <div className={classNames("item-circle", {"item-circle-active": activeStep === 1})}>1</div>
          </div>

          <div className="line"></div>

          <div className="item">
            <div className={classNames("item-circle", {"item-circle-active": activeStep === 2})}>2</div>
          </div>

          <div className="line"></div>

          <div className="item">
            <div className={classNames("item-circle", {"item-circle-active": activeStep === 3})}>3</div>
          </div>

        <div className="line"></div>

          <div className="item">
            <div className={classNames("item-circle", {"item-circle-active": activeStep === 4})}>4</div>
          </div>

        <div className="line"></div>

          <div className="item">
            <div className={classNames("item-circle", {"item-circle-active": activeStep === 5})}>5</div>
          </div>

          <div className="line"></div>

          <div className="item">
            <div className={classNames("item-circle", {"item-circle-active": activeStep === 6})}>6</div>
          </div>

          <div className="line"></div>

          <div className="item">
            <div className={classNames("item-circle", {"item-circle-active": activeStep === 7})}>7</div>
          </div>

          <div className="line"></div>
          
          <div className="item">
            <div className={classNames("item-circle", {"item-circle-active": activeStep === 8})}>8</div>
          </div>
    </div>


    <div className='application-progress-text'>
      <span className={classNames({"active-text": activeStep === 1})}>Choosen Class</span>
      <span className={classNames({"active-text": activeStep === 2})}>{finalPathName === 'company'?'Company details' : 'Personal details'}</span>
      <span className={classNames({"active-text": activeStep === 3})}>Contact Details</span>
      <span className={classNames({"active-text": activeStep === 4})}>{finalPathName === 'company'? 'Directors/ Shareholders details':'Educational details'}</span>
      <span className={classNames({"active-text": activeStep === 5})}>{finalPathName === 'company'? 'Projects accomplished' :'Certification details'}</span>
      <span className={classNames({"active-text": activeStep === 6})}>{finalPathName === 'company'? 'Attachments' : 'References'}</span>
      <span className={classNames({"active-text": activeStep === 7})}>Review Details & Submit</span>
      <span className={classNames({"active-text": activeStep === 8})}>Payment</span>
    </div>  
  </>
  );
};

export default TransactionProgress;